import { CategoryConfig } from '@/types/category';
import { Activity } from 'lucide-react';

export const yogaMeditationConfig: CategoryConfig = {
  name: 'Yoga Meditation',
  color: 'from-purple-500 to-pink-500',
  icon: Activity,
  description: 'Mindful meditation sessions combined with yoga positioning and breathing techniques',
  defaultPrompt: `Create a yoga meditation session that combines mindfulness with gentle yoga positioning. Include specific beginning positions, breathing techniques, and collective ending positions. Focus on the mind-body connection, proper alignment, and creating a peaceful transition between poses. Incorporate meditation and mindfulness throughout the physical practice.`,
  samplePrompt: `Generate a 10-15 minute yoga meditation session with:
- Opening position and breath awareness
- 2-3 gentle transitional poses with mindful breathing
- Extended meditation in a comfortable seated or resting position
- Collective ending position for group harmony
- Safety cues and modification options
- Integration of mindfulness throughout movement`,
  personalizedTemplate: `Create a personalized yoga meditation session incorporating:

**Positioning Structure:**
- **Opening Position**: Begin in [comfortable seated position/child's pose/mountain pose]
- **Transitional Flow**: Include 2-3 gentle movements with breath synchronization
- **Meditation Position**: Extended mindfulness practice in [preferred position]
- **Closing Position**: End in a collective position suitable for group practice

**Personalization Elements:**
- Adapt instructions based on experience level and physical capabilities
- Include specific breath work and mindfulness cues
- Provide modifications for different body types and limitations
- Focus on the stated intentions and goals for the practice

**Safety & Inclusivity:**
- Always offer pose modifications and alternatives
- Emphasize listening to the body over achieving "perfect" poses
- Include clear alignment cues for safety
- Create space for individual expression within the group practice

The session should seamlessly blend physical yoga elements with deep meditation, creating a holistic mind-body experience.`,
  personalizedTemplateTitle: 'Personalized Yoga Meditation Session',
  personalizedTemplateDuration: 900, // 15 minutes
};